module.exports = __webpack_public_path__ + "static/media/measure_circle_x.3ca5e0f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/utils/measure_circle_x.png
// module id = 607
// module chunks = 0